<template>
  <div>

    <div class="header" v-on:mouseleave="menuLeave()">
      <div class="grab">
        <h1><a class="navbar-brand" v-on:click="homeClick()"><img v-bind:src="'static/img/' + $t('logo_name')" alt="">
        </a></h1>
        <nav id="gnb">
          <!-- nav -->
          <ul class="nav">
            <li v-for="(menu,idx0) in menus" v-if="idx0!=0">
              <a v-on:mouseover="menuOver(idx0)" v-on:click="menuClick(idx0,0)" v-bind:class="{active:mainState.menuIndex==idx0}">
                {{$t(menu.title)}}
                <span class="line"></span>
              </a>
              <!-- 여기도 보이던가 말던가 한다. -->
              <ul class="submenu" v-if="idx0==displayMenu && showMenu">
                <li v-for="(subname,idx1 ) in menu.subs">
                  <a v-on:click="menuClick(idx0,idx1)">{{$t(subname)}}</a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <div class="header_btn">
          <button type="button" class="mobile_gnb_toggle">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>
      </div>
      <div class="nav_bg" v-if="showMenu"
           v-bind:class="{nav_bg01:displayMenu==1 , nav_bg02:displayMenu==2 ,nav_bg03:displayMenu==3 ,nav_bg04:displayMenu==4 } ">
        <!-- 상황에 따라서 항상 보이던지 한다. -->
        <div class="grab">
          <h2
            v-bind:class="{ico_1:(mainState.menuIndex==1) ,ico_2:(mainState.menuIndex==2),ico_3:(mainState.menuIndex==3),ico_4:(mainState.menuIndex==4)}"
            id="nav_title" v-if="staticMenu==true">
            {{$t(menus[mainState.menuIndex].title)}}
          </h2>
        </div>
      </div>
    </div>

    <!-- menu bar -->
    <div id="location_wrap" v-if="staticMenu==true">
      <div class="grab">
        <div class="location">
          <div class="home">
            <a v-on:click="homeClick()"><span class="glyphicon glyphicon-home"><strong
              class="sr-only">홈으로 이동</strong></span></a>
          </div>
          <div class="dropdown popup-dropdown">
            <a><span>{{$t(menus[mainState.menuIndex].title)}}&nbsp;&nbsp; </span><i
              class="glyphicon glyphicon-menu-down"></i></a>
            <div class="popup-dropdown-content">
              <ul>
                <li v-for="(menu,idx0) in menus" v-if="idx0">
                  <a v-on:click="menuClick(idx0,0)">{{$t(menu.title)}}</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="dropdown popup-dropdown">
            <a>
              <span>{{$t(menus[mainState.menuIndex].subs[mainState.subIndex])}}&nbsp;&nbsp;</span><i
              class="glyphicon glyphicon-menu-down"></i>
            </a>
            <div class="popup-dropdown-content">
              <ul>
                <li v-for="(subname,index) in menus[mainState.menuIndex].subs"><a v-on:click="menuClick(mainState.menuIndex,index)">{{$t(subname)}}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Phones&Tablets menu -->
    <div id="mobile_nav" class="panel-group" role="tablist" aria-multiselectable="true">
      <div class="panel" v-for="(menu,idx0) in menus" v-if="idx0!=0">
        <div class="panel-heading">
            <a>{{$t(menu.title)}}</a>
              <h2 class="panel-title">
          </h2>
        </div>
        <div>
          <ul>
            <li v-for="(subname,idx1 ) in menu.subs">
              <a class="mobile_sub" v-on:click="menuClick(idx0,idx1)">{{$t(subname)}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- //Phones&Tablets menu -->
  </div>
</template>

<script>
  import {EventBus} from '../js/EventBus'
  import Constant from '../constant'
  import { mapState } from 'vuex'
  import _ from 'lodash'

  export default {
    name: 'Menu',
    data: function () {
      return {
        menus: [
          {title: 'AA', subs: ['aa', 'ss', 'researchresult']},
          {title: 'centerintro', subs: ['centerpurpose','centerhistory', 'centerperson', 'centerlocation', 'centerci']},
          {title: 'research', subs: ['researchfield', 'researchperform', 'researchresult']},
          {title: 'environmentdata', subs: ['datasystem', 'wiseweb']},
          {title: 'notice', subs: ['centernews', 'centeractive']}

        ],
        //currentMenu: 0,
        //currentSubMenu: 0,
        langText: 'ENGLISH',
        //displayMenu: 0,
        //activeMenu: false,
        overIndex:0
        //currentLang : this.$i18n.locale
      }
    },
    methods: {
      menuOver: function (index) {

        //this.active = !this.active;
        //this.displayMenu = index
        //this.activeMenu = true
        this.overIndex = index
      },
      menuLeave: function () {
        console.log('## leave')
        //this.displayMenu = this.mainState.menuIndex;
        //this.activeMenu = false
        this.overIndex = 0
      },
      menuClick: function (index0, index1) {
        this.$store.commit(Constant.MAIN_STATE, {menuIndex:index0 , subIndex:index1})
        //this.currentMenu = index0
        //this.displayMenu = index0
        //this.currentSubMenu = index1
        //console.log('## ' + index0 + ' ' + index1)
        //this.staticMenu = true
        //console.log('## mainState.menuIndex : ' + this.mainState.menuIndex)
        //this.$emit('goPage' , index0 , index1)
        EventBus.$emit('go-page-index', index0-1, index1)
      },
      homeClick: function()
      {
        //this.staticMenu = false
        //this.activeMenu = false
        //this.$emit('goHome')
        this.overIndex = 0
        EventBus.$emit('go-page-name', 'dashboard')
      }
    },
    mounted: function()
    {
      console.log('## MENU INIT')
      console.log(this.$route.path);
      var rpath = this.$route.path

      console.log('## MENU INIT ' + rpath)


      if(rpath.indexOf("/dashboard") !=-1){
          console.log('## MENU HIDE')
          this.staticMenu = false
          this.$store.commit(Constant.MAIN_STATE, {menuIndex:0 , subIndex:0})
        }
    },
    computed: _.extend({
      showMenu: function ()
      {
        if (this.staticMenu == true)
          return true
        if (this.overIndex !=0)
          return true
        return false
      },
      staticMenu: function()
      {
        if(this.mainState.menuIndex==0) return false
        return true
      },
      displayMenu: function() {
        if(this.overIndex != 0) return this.overIndex
        else
          return this.mainState.menuIndex
      }
    },mapState(['mainState'])),
    watch: {
      '$route' (to, from) {
        // react to route changes...
        console.log("## router changed : " + to.path)
        if(to.path == "/dashboard" || to.path=="/") {
          this.staticMenu = false
          this.$store.commit(Constant.MAIN_STATE, {menuIndex:0 , subIndex:0})
        }
        else {
          //this.staticMenu = true;
          if(to.path=='/centerpurpose') { this.$store.commit(Constant.MAIN_STATE, { menuIndex:1 , subIndex:0}), this.currentSubMenu=0 }
          if(to.path=='/centerhistory') { this.$store.commit(Constant.MAIN_STATE, { menuIndex:1 , subIndex:1}), this.currentSubMenu=1 }
          if(to.path=='/centerperson') { this.$store.commit(Constant.MAIN_STATE, { menuIndex:1 , subIndex:2}), this.currentSubMenu=2 }
          if(to.path=='/centerlocation') { this.$store.commit(Constant.MAIN_STATE, { menuIndex:1 , subIndex:3}), this.currentSubMenu=3 }
          if(to.path=='/centerCI') { this.$store.commit(Constant.MAIN_STATE, { menuIndex:1 , subIndex:4}), this.currentSubMenu=4 }

          if(to.path=='/researchfield')  { this.$store.commit(Constant.MAIN_STATE, { menuIndex:2 , subIndex:0}) , this.currentSubMenu=0 }
          if(to.path=='/researchperform') { this.$store.commit(Constant.MAIN_STATE, { menuIndex:2 , subIndex:1}), this.currentSubMenu=1 }
          if(to.path=='/researchresult') { this.$store.commit(Constant.MAIN_STATE, { menuIndex:2 , subIndex:2}), this.currentSubMenu=2 }
          if(to.path=='/researchwrite') { this.$store.commit(Constant.MAIN_STATE, { menuIndex:2 , subIndex:2}), this.currentSubMenu=2 }

          if(to.path=='/datasystem') { this.$store.commit(Constant.MAIN_STATE, { menuIndex:3 , subIndex:0}), this.currentSubMenu=0 }
          if(to.path=='/datawise') { this.$store.commit(Constant.MAIN_STATE, { menuIndex:3 , subIndex:1}), this.currentSubMenu=1 }

          if(to.path=='/noticeactive') { this.$store.commit(Constant.MAIN_STATE, { menuIndex:4 , subIndex:0}), this.currentSubMenu=0 }
          if(to.path=='/noticenews') { this.$store.commit(Constant.MAIN_STATE, { menuIndex:4 , subIndex:0}), this.currentSubMenu=1 }



          /*
          'noticewrite'
          'noticedetail'*/


        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submenu {
    position: absolute;
    top: 105px;
    left: 15px;
  }

  .submenu li {
    float: left;
    margin: 3px 0;
    padding-right: 40px;
  }

  .submenu li a {
    color: #fff;
    font-size: 15px;
    font-weight: 400;
    white-space: nowrap;
  }

  .submenu li a:focus, .submenu li a:hover {
    color: #fff;
    font-weight: 500;
    text-decoration: underline;
  }

</style>



// WEBPACK FOOTER //
// src/components/Menu.vue